/**
 * tdesign v1.0.6
 * (c) 2023 TDesign Group
 * @license MIT
 */

import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';

function getAttach(node) {
  var attachNode = isFunction(node) ? node() : node;
  if (isString(attachNode)) {
    return document.querySelector(attachNode);
  }
  if (attachNode instanceof HTMLElement) {
    return attachNode;
  }
  return document.body;
}
function stopPropagation(event) {
  event.stopPropagation();
}
function preventDefault(event, isStopPropagation) {
  if (typeof event.cancelable !== "boolean" || event.cancelable) {
    event.preventDefault();
  }
  if (isStopPropagation) {
    stopPropagation(event);
  }
}

export { getAttach, preventDefault, stopPropagation };
//# sourceMappingURL=dom.js.map
